// 不以科学计数法显示
export default num => {
  //处理非数字
  if (isNaN(num)) {
    return num;
  }
  if (typeof num === 'string') {
    num -= 0;
  }
  //处理不需要转换的数字
  let str = '' + num;
  if (!/e/i.test(str)) {
    return num;
  }
  let fixedLength = 17;
  if (num % 1 !== 0) {
    fixedLength = 17 - str.split('.')[0].length;
  }
  if (fixedLength < 0) {
    fixedLength = 0;
  }
  let output = num.toFixed(fixedLength).replace(/\.?0+$/, '');
  if (output.slice(-1) === '.') {
    output = output.slice(0, -1);
  }
  return output;
};
